import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { InvestmentInstructionSubmissionAffectedAccount } from '../../../../models/submissions/investment-instruction-submission-affected-account';
import { AccountType } from '../../../../models/transactions/account-type';

@Component({
  selector: 'app-investment-instruction-submission-affected-account-list-item',
  templateUrl: './investment-instruction-submission-affected-account-list-item.component.html',
  styleUrls: ['./investment-instruction-submission-affected-account-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InvestmentInstructionSubmissionAffectedAccountListItemComponent {
  @Input() affectedAccount!: InvestmentInstructionSubmissionAffectedAccount;
  @Input() lastInList: boolean = false;
  @Input() accountType: AccountType | null = null;
  @Output() viewAccountClicked = new EventEmitter<void>();
}
